import api from "./AxiosInterceptor";
import EndpointService from "./EndpointService";

export const generateJwtTokenService = async () => {
  const url = EndpointService("generateJwtToken");
  const response = await api.get(url);
  return response.data;
};

export const getRefreshJwtTokenService = async () => {
  const url = EndpointService("refreshJwtToken");
  const response = await api.get(url);
  return response.data;
};

export const performLogoutService = async () => {
  const url = EndpointService("logOut");
  const response = await api.get(url);
  return response;
};
